module.exports = __webpack_public_path__ + "img/V7.05e3138c.jpg";